<template>
  <q-dialog v-model="deleteDialog" transition-show="fade" transition-hide="fade">
    <div class="initialBackDrop" style="min-height: 100vh">
      <div class="q-pa-md q-gutter-sm" style="width: 80ex; margin-left: auto; margin-right: auto; margin-top: 5%; margin-bottom: auto; border-radius: 10px;">
        <q-card style="padding: 50px; border-radius: 10px;" class="q-pa-md">
          <div align="right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin: -70px -40px 0px 0px;" /></div>
          <div class="dialogText">{{deleteDialogMessage}}</div>

          <br />

          <q-card-actions align="center" class="text-primary">
            <q-btn
              label="Cancel"
              color="cancelButton"
              class="q-ml-sm dialogButton"
              no-caps
              v-close-popup
            />
            <q-btn
              label="Delete"
              @click="deleteRecord"
              color="primary"
              class="dialogButton"
              no-caps
              v-close-popup
            />
          </q-card-actions>
        </q-card>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { computed, ref } from "vue";
import CommonHelper from "../helper/CommonHelper";
import NotificationHelper from "../helper/NotificationHelper";
import EmailService from "../service/EmailService.js";
import LogService from '../service/LogService';
import MayanService from '../service/MayanService';

export default {
  name: "FileDelete",
  props: {
    currentUserUID: String,
    ipAddress: String,
    uploadContainer: Object,
    foldersTable: Object
  },
  setup(props) {
    const deleteDialog =  ref(false);
    const documentId = ref("");
    const fileName = ref("");
    const scopeName = ref("");

    const deleteDialogMessage = computed(() => {
      return `Delete "${fileName.value}" (${scopeName.value})?`;
    });

    function deleteRow(paramDocumentId, paramFileName, paramScopeName) {
      documentId.value = paramDocumentId;
      fileName.value = paramFileName;
      scopeName.value = paramScopeName;
      deleteDialog.value = true;
    }

    async function deleteRecord() {
      try {
        if (documentId.value !== undefined) {
          NotificationHelper.createNotification("Deleting File...");
          const response = await MayanService.deleteFile(documentId.value);
          LogService.logDocumentChanges(props.currentUserUID, props.ipAddress, "Delete", response);
          CommonHelper.deleteZipFileData(documentId.value);
          CommonHelper.deleteFromTableInput(documentId.value);

          if (props.uploadContainer && props.uploadContainer.metadataToEdit && props.uploadContainer.metadataToEdit.id === documentId.value) {
            props.uploadContainer.cancelEditMetadataMode();
          }

          NotificationHelper.createSuccessNotification("File Deleted Successfully");
        }
      } catch (error) {
        EmailService.sendErrorEmail("FileDelete.vue - deleteRecord", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    return {
      //variable properties
      deleteDialog,
      deleteDialogMessage,

      //functions
      deleteRow,
      deleteRecord
    };
  },
};
</script>